<div class="modal-header">
    <h2 style="font-weight: bold;color: black;">Documentos pendientes por pagar a Grupo TSI</h2>
    <button type="button" class="close" aria-label="Close" (click)="cerrar()" tabindex="13">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body ">
    <ngb-tabset>
        <ngb-tab>
            <ng-template ngbTabTitle> Vencidas</ng-template>
            <ng-template ngbTabContent>
                <br>
                <div class="table-responsive" style="min-height: 45vh;max-height: 60vh;">
                    <table id="general" class="table table-sm table-striped-simulada table-bordered ">
                        <thead>
                            <tr>
                                <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                                <th> TipDoc </th>
                                <th> Comprobante </th>
                                <th> Operación </th>
                                <th> F.Emisión </th>
                                <th> F.Vencimiento </th>
                                <th> Dias Mora </th>
                                <th> Moneda </th>
                                <th style="white-space: nowrap"> Total Documento </th>
                                <th style="white-space: nowrap"> Total a Cobrar </th>
                                <th style="white-space: nowrap"> Banco </th>
                                <th style="white-space: nowrap"> #-Banco </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let est of facturasVencidas" (click)="onClick(est)"
                                [ngClass]="{'nombre-de-la-clase': est == this.esttemp}" style="cursor: pointer;">
                                <td style="text-align: center;">
                                    <div class="btn-group dropright" ngbDropdown container="body" role="group"
                                        aria-label="Button group with nested dropdown"
                                        style="margin: 0px; padding: 0px;">
                                        <button class="btn btn-sm" ngbDropdownToggle style="margin: 0px; padding: 0px;">
                                            <i class=" fas fa-align-left"></i>
                                        </button>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <button class="dropdown-item" (click)="imprimirComprobante(est)"><i
                                                    class="fas fa-print font-14" style="margin-right: .3rem"></i>
                                                Imprimir comprobante</button>
                                        </div>
                                    </div>
                                </td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.abrevi}}
                                </td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.serie}} - {{est.numero}}
                                </td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    style="white-space: nowrap">{{est.desoperac}}</td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.femisi | date:'dd/MM/yyyy'}}
                                </td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.fvenci | date:'dd/MM/yyyy'}}
                                </td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}">{{est.mora}}
                                </td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}">
                                    {{est.tipmon}}</td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    class="sorting" style="text-align: right; white-space: nowrap">
                                    {{est.tdocumento | number:'.2-2'}}
                                </td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    style="text-align: right">{{est.saldo | number:'.2-2'}}</td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    style="white-space: nowrap">{{est.desban}}</td>
                                <td [ngClass]="{'error': (fechaActual > est.fvenci && radioValue == 'S')}"
                                    style="white-space: nowrap">{{est.numbco}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab>
            <ng-template ngbTabTitle> Por vencer</ng-template>
            <ng-template ngbTabContent>
                <br>

                <div class="table-responsive" style="min-height: 45vh;max-height: 60vh;">
                    <table id="general" class="table table-sm table-striped-simulada table-bordered">
                        <thead>
                            <tr>
                                <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                                <th> TipDoc </th>
                                <th> Comprobante </th>
                                <th> Operación </th>                       
                                <th> F.Emisión </th>
                                <th> F.Vencimiento </th>
                                <th> Dias Mora </th>
                                <th> Moneda </th>
                                <th style="white-space: nowrap"> Total Documento </th>
                                <th style="white-space: nowrap"> Total a Cobrar </th>
                                <th style="white-space: nowrap"> Banco </th>
                                <th style="white-space: nowrap"> #-Banco </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let est of facturasPorVencer" (click)="onClick(est)"
                                [ngClass]="{'nombre-de-la-clase': est == this.esttemp}" style="cursor: pointer;">
                                <td style="text-align: center;">

                                    <div class="btn-group dropright" ngbDropdown container="body" role="group"
                                        aria-label="Button group with nested dropdown"
                                        style="margin: 0px; padding: 0px;">
                                        <button class="btn btn-sm" ngbDropdownToggle style="margin: 0px; padding: 0px;">
                                            <i class=" fas fa-align-left"></i>
                                        </button>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <button class="dropdown-item" (click)="imprimirComprobante(est)"><i
                                                    class="fas fa-print font-14" style="margin-right: .3rem"></i>
                                                Imprimir comprobante</button>
                                        </div>

                                    </div>

                                </td>
                                <td class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.abrevi}}
                                </td>
                                <td class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.serie}} - {{est.numero}}
                                </td>
                                <td style="white-space: nowrap">{{est.desoperac}}</td>
                                <td class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.femisi | date:'dd/MM/yyyy'}}
                                </td>
                                <td class="sorting" style="text-align: left; white-space: nowrap">
                                    {{est.fvenci | date:'dd/MM/yyyy'}}
                                </td>
                                <td>{{est.mora}}</td>
                                <td>{{est.tipmon}}</td>
                                <td class="sorting" style="text-align: right; white-space: nowrap">
                                    {{est.tdocumento | number:'.2-2'}}
                                </td>
                                <td style="text-align: right">{{est.saldo | number:'.2-2'}}</td>
                                <td style="white-space: nowrap">{{est.desban}}</td>
                                <td style="white-space: nowrap">{{est.numbco}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </ng-template>
        </ngb-tab>
    </ngb-tabset>

    <div class="alert alert-danger mt-1 col-md-12" role="alert">
        <h3 class="alert-heading font-weight-bold">Cuentas Bancarias Grupo TSI</h3>
        <div class="container">
            <div class="row row-cols-xl-3 row-cols-lg-2 row-cols-md-1 flex-wrap">
              <div class="col font-weight-bold" *ngFor="let lst of glosa52">- {{lst}}</div>
            </div>
          </div>
        <hr>
    </div>
</div>